var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 147,
    viewBox: "0 0 183 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182.173,
    height: 147,
    rx: 2,
    fill: "#F4F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59.8477,
    y: 8.54956,
    width: 114.434,
    height: 131.533,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 5.26123,
    width: 23.676,
    height: 5.26132,
    rx: 2,
    fill: "#6D788C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 59.1899,
    width: 23.676,
    height: 5.26132,
    rx: 2,
    fill: "#6D788C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 123.641,
    width: 23.676,
    height: 5.26132,
    rx: 2,
    fill: "#6D788C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.76123,
    y: 13.6533,
    width: 45.6943,
    height: 6.89199,
    rx: 1.5,
    fill: "#DADBDD",
    stroke: "#6D788C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6089,
    y: 24.176,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#6D788C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 65.6089,
    y: 59.6899,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 101.123,
    y: 24.176,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 101.123,
    y: 59.6899,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 136.637,
    y: 24.176,
    width: 31.8833,
    height: 31.8833,
    rx: 1.5,
    fill: "white",
    stroke: "#DADBDD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 67.0818,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 23.676,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3701,
    y: 36.1716,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3701,
    y: 71.0278,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 105.884,
    y: 36.1716,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 105.884,
    y: 71.0278,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 141.398,
    y: 36.1716,
    width: 22.3606,
    height: 4.60366,
    rx: 2,
    fill: "#DADBDD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9736,
    y: 42.7483,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 74.9736,
    y: 77.6045,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 110.488,
    y: 42.7483,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 110.488,
    y: 77.6045,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 146.002,
    y: 42.7483,
    width: 13.1533,
    height: 1.973,
    rx: 0.986498,
    fill: "#DADBDD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 77.6045,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 34.1987,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 88.1272,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 44.7212,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 98.6499,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 109.172,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 5.26123,
    y: 131.533,
    width: 46.6943,
    height: 7.89199,
    rx: 2,
    fill: "#DADBDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout1);
export default __webpack_public_path__ + "static/media/layout1.084f3b3e8275d508b46367339272aa93.svg";
export { ForwardRef as ReactComponent };